import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import SummaryWarningBox from '../boxes/SummaryWarningBox';
import { MoneyType } from '../../propTypes';

const OrderingDebtWarning = ({ orderingDebt, hasPurchaseOrdersNearToDebt }) => {
  const shouldShow = useMemo(
    () => orderingDebt?.amount > 0 || hasPurchaseOrdersNearToDebt,
    [orderingDebt, hasPurchaseOrdersNearToDebt],
  );

  const title = useMemo(() => {
    if ((!!orderingDebt && hasPurchaseOrdersNearToDebt)) {
      return 'Tienes OCs vencidas y OCs que vencen en 5 días';
    }
    if (orderingDebt?.amount > 0) {
      return 'Tienes OCs vencidas';
    }
    if (hasPurchaseOrdersNearToDebt) {
      return 'Tienes OCs que vencen en 5 días';
    }
    return null;
  }, [orderingDebt, hasPurchaseOrdersNearToDebt]);

  if (!shouldShow) return null;

  return (
    <SummaryWarningBox id="ordering-debt-warning">
      <Typography variant="h6">
        {title},{' '}
        <Link href="/app/sales/ordering/operations">
          págalas aquí
        </Link>
      </Typography>
    </SummaryWarningBox>
  );
};

OrderingDebtWarning.propTypes = {
  orderingDebt: MoneyType,
  hasPurchaseOrdersNearToDebt: PropTypes.bool,
};

OrderingDebtWarning.defaultProps = {
  orderingDebt: {
    amount: 0,
    currency: null,
  },
  hasPurchaseOrdersNearToDebt: false,
};

export default OrderingDebtWarning;
